// Story Week™ anonymous session helper.
// Uses localStorage `sw_anon_id` so a visitor can close the tab and come back.
import api from "./api";

const ANON_KEY = "sw_anon_id";

export function getAnonId() {
  try { return localStorage.getItem(ANON_KEY) || null; } catch (e) { return null; }
}

export function setAnonId(id) {
  try { localStorage.setItem(ANON_KEY, id); } catch (e) { /* noop */ }
}

export function clearAnonId() {
  try { localStorage.removeItem(ANON_KEY); } catch (e) { /* noop */ }
}

export async function startSession(referrer = null) {
  const existing = getAnonId();
  const res = await api.post("/story_week/start", { anon_id: existing, referrer });
  setAnonId(res.data.anon_id);
  return res.data;
}

export async function getSession() {
  const id = getAnonId();
  if (!id) return null;
  try {
    const res = await api.get(`/story_week/${id}`);
    return res.data;
  } catch (e) {
    return null;
  }
}

export async function saveDay(day, text, extras = {}) {
  const anon_id = getAnonId();
  if (!anon_id) throw new Error("No Story Week session");
  const payload = { anon_id, day, text, ...extras };
  const res = await api.post("/story_week/day", payload);
  return res.data;
}

export async function transcribeVoice(blob) {
  const anon_id = getAnonId();
  if (!anon_id) throw new Error("No Story Week session");
  const fd = new FormData();
  fd.append("anon_id", anon_id);
  fd.append("audio", blob, "recording.webm");
  const res = await api.post("/story_week/voice", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return res.data;
}

export async function uploadPhoto(file) {
  const anon_id = getAnonId();
  if (!anon_id) throw new Error("No Story Week session");
  const fd = new FormData();
  fd.append("anon_id", anon_id);
  fd.append("file", file);
  const res = await api.post("/story_week/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return res.data;
}

export async function claimSession(storytellerName, storytellerRelation = "Other") {
  const anon_id = getAnonId();
  if (!anon_id) throw new Error("No Story Week session");
  const res = await api.post("/story_week/claim", {
    anon_id,
    storyteller_name: storytellerName,
    storyteller_relation: storytellerRelation,
  });
  return res.data;
}

export async function sendInvite({ senderName, senderEmail, recipientName, recipientEmail, relation, message }) {
  const anon_id = getAnonId();
  const res = await api.post("/story_week/invite", {
    anon_id,
    sender_name: senderName,
    sender_email: senderEmail,
    recipient_name: recipientName,
    recipient_email: recipientEmail,
    relation,
    message,
  });
  return res.data;
}
